/**
 * Created by yniran on 12/20/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        BaseModel = require("models/BaseModel"),
        ChatInputModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        ChatInputModel = BaseModel.extend({
            name: "ChatInputModel",
            defaults: {
                chatActive: false,
                chatLine: null,
                userTyping: false
            }
        });
    });

    return ChatInputModel;
});
